export const ONBOARDING_LINKS = {
    CHILDREN: 'https://secure.brandnewday.nl/rekening-openen/kinderrekening-beleggen',
};

export const modelPortfolioUrls = {
    modelInvestment: 'https://new.brandnewday.nl/particulier/bank-modelbeleggen/',
    firstUmbrellaFund: 'https://www.brandnewday.nl/content/app/pdf/documentencentrum/Prospectus/Prospectus-BND-PFI.pdf',
    secondUmbrellaFund:
        'https://www.brandnewday.nl/content/app/pdf/documentencentrum/Prospectus/Prospectus-BND-PFII.pdf',
};

export const DOCUMENT_CENTRUM_URL = 'https://new.brandnewday.nl/documentencentrum/';
export const FAQ_INVESTMENT_ADVICE_URL =
    'https://new.brandnewday.nl/veelgestelde-vragen/beleggen/kunnen-jullie-mij-beleggingsadvies-geven/';
export const CALL_EXPERT_URL = 'https://new.brandnewday.nl/belafspraak/';
export const AFM_URL =
    'https://www.afm.nl/nl-nl/sector/themas/dienstverlening-aan-consumenten/informatieverstrekking/essentiele-informatiedocument-eid';
export const PRIVACY_URL =
    'https://new.brandnewday.nl/wp-content/uploads/2019/05/Def_privacy_statement_algemeen_2019.pdf';
export const MIJNPENSIOENOVERZICHT_URL = 'https://www.mijnpensioenoverzicht.nl/';
export const PRIVACY_STATEMENT_PENSION = 'https://new.brandnewday.nl/privacy-en-cookiestatement/#intro';

const pessimisticBlue = '#2147CF';
const medianBlue = '#3661FE';
const optimisticBlue = '#6486FF';
const bndBlue = '#07568A';
const bndPink = '#E66082';
const bndPinkLight = '#E6608233';
const bndGreen = '#0BA287';
const bndBlack = '#333333';
const bndGrey = '#646464';
const bndWhite = '#FEFEFE';
const bndYellow = '#FFB900';

const shares = ['#D09803', '#E9B93C', '#FFDA75', '#FFE8AC'];
const obligates = ['#2F4FA3', '#3875AA', '#72CBD8', '#A3F3FF'];

const listColors = [
    '#2F4FA3',
    '#3875AA',
    '#92BED4',
    '#72CBD8',
    '#D2E773',
    '#A2D87A',
    '#73CB81',
    '#FFEDBE',
    '#FFDD83',
    '#BF4A28',
];

const total = [...listColors, ...listColors, ...listColors];

export const COLORS = {
    pessimisticBlue,
    medianBlue,
    optimisticBlue,
    bndBlue,
    bndPink,
    bndPinkLight,
    bndGreen,
    bndBlack,
    bndGrey,
    bndWhite,
    shares,
    obligates,
    total,
    bndYellow,
};

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export const breakpoints: { minWidth: number; tag: Breakpoint }[] = [
    { minWidth: 640, tag: 'sm' },
    { minWidth: 768, tag: 'md' },
    { minWidth: 1024, tag: 'lg' },
    { minWidth: 1280, tag: 'xl' },
    { minWidth: 1536, tag: '2xl' },
];

export const SELECTED_FUND_COLORS = [COLORS.bndYellow, COLORS.bndBlue, COLORS.bndPink];
export const LINE_CHART_COLORS: { chart: string; legend: string }[] = [
    // COLORS.optimisticBlue,
    // COLORS.medianBlue,
    // COLORS.pessimisticBlue
    {
        chart: bndBlue + '26',
        legend: '#CDDDE8',
    },
    {
        chart: bndBlue,
        legend: bndBlue,
    },
    {
        chart: bndBlue + '99',
        legend: '#3978A1',
    },
];

export const DISABLED_OPTION_PLACHOLDER_ID = 'DISABLED_OPTION_PLACHOLDER_ID';

export type ROBOT_ENVIRONMENT = 'MyBND' | 'Marketing' | 'Advisor' | 'External' | 'Rich Media';
export type CLIENT_DETAILS_OPTIONS = 'first' | 'last' | 'default';

export type RiskProfile = 'veryDefensive' | 'defensive' | 'neutral' | 'offensive' | 'veryOffensive';
export type RiskProfileId = '8' | '9' | '10' | '11' | '12';

export const riskProfiles = {
    veryDefensive: '8',
    defensive: '9',
    neutral: '10',
    offensive: '11',
    veryOffensive: '12',
    default: '10',
};

export const riskProfileIds = {
    '8': 'veryDefensive',
    '9': 'defensive',
    '10': 'neutral',
    '11': 'offensive',
    '12': 'veryOffensive',
};

export const MAX_NUMBER_SUPPLEMENT_ACCS = 10;
export const DEFAULT_PENSION_AGE = 68;
export const MAX_MORE_PENSION_THAN_INCOME = 50000;
export const LAST_SECTION_INDEX = 5;
export const SUMMARY_SECTION_INDEX = 6;

export const MIN_AGE_CLIENT = 18;
export const MONTHS_IN_YEAR = 12;
export const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

export const EXPECTED_YEARS_TO_RECEIVE_PENSION_OVER = 20;

export const EMAIL_HOOK_URL = 'https://hooks.zapier.com/hooks/catch/4760236/ojt53tq/';
export const EMAIL_HOOK_PENSION_ROBOT_URL = 'https://hooks.zapier.com/hooks/catch/4760236/bio4g2y';

export const MYBND_FINISHED_LINK = '/mijn-tools';

export const FOR_LINK =
    'https://new.brandnewday.nl/veelgestelde-vragen/jaarruimte-en-reserveringsruimte/wat-is-de-%C2%91toevoeging-oudedagsreserve-of-de-fiscale-oudedagsreserve-for/';

export const PENSION_ROBOT_MPO_VIDEO_LINK = 'https://player.vimeo.com/video/728816379?h=46827587fd';
